function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 0C2.24283 0 0 2.24305 0 5C0 7.75695 2.24283 10 5 10C7.75717 10 10 7.75695 10 5C10 2.24305 7.75717 0 5 0ZM5 8.33334C4.7701 8.33334 4.58334 8.14637 4.58334 7.91668C4.58334 7.68699 4.77012 7.50002 5 7.50002C5.22988 7.50002 5.41666 7.68699 5.41666 7.91668C5.41666 8.14637 5.2299 8.33334 5 8.33334ZM5.41666 6.875C5.41666 6.99016 5.32348 7.08334 5.20832 7.08334H4.79166C4.6765 7.08334 4.58332 6.99016 4.58332 6.875V1.875C4.58332 1.75984 4.6765 1.66666 4.79166 1.66666H5.20832C5.32348 1.66666 5.41666 1.75984 5.41666 1.875V6.875Z"
});

function SvgAtencion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtencion);
export default __webpack_public_path__ + "static/media/atencion.36c0322a.svg";
export { ForwardRef as ReactComponent };